import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function uppercaseLettersValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const regex = /[A-Z]/g;
    return (control !== null && control.value !== null && control.value !== undefined)
      && regex.test(control.value)
      ? null
      : { uppercaseLetter: { value: control.value } };
  };
}
